// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountDetailsStyles from "@rpsc/App/SharedStyles/MyAccountDetailsStyles";
import { headerStyles } from "@rpsc/Overrides/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { hideElementOnPrint } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

headerStyles.buttonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        gap: 24px;
    `,
};
headerStyles.titleGridItem = {
    width: 12,
};

headerStyles.title = {
    variant: "h1",
    as: "h1",
};

headerStyles.narrowOverflowMenu = {
    cssOverrides: {
        menu: css`
            ${hideElementOnPrint}
        `,
    },
};

headerStyles.printLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.printLink,
};

headerStyles.reorderLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.requoteLink,
};

headerStyles.shareEntityButtonStyles = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.emailLink,
};

headerStyles.headerGridContainer = {
    gap: 0,
};
